import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { getInterval, getPreviousPeriod, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var mockCurrentPeriodData = [
    { createdAndOwnedFiles: 12, previousPeriod: 8, teamAverage: 15 },
    { createdAndOwnedFiles: 8, previousPeriod: 12, teamAverage: 18 },
    { createdAndOwnedFiles: 15, previousPeriod: 10, teamAverage: 22 },
    { createdAndOwnedFiles: 6, previousPeriod: 9, teamAverage: 14 },
    { createdAndOwnedFiles: 20, previousPeriod: 15, teamAverage: 25 },
    { createdAndOwnedFiles: 11, previousPeriod: 7, teamAverage: 16 },
    { createdAndOwnedFiles: 9, previousPeriod: 13, teamAverage: 19 }
];
export var createdAndOwnedFiles = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periodsData = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periodsData, previousPeriods);
    var periods = periodsData.map(function (period, idx) {
        var _a;
        var mockData = mockCurrentPeriodData[idx % mockCurrentPeriodData.length];
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        return {
            period: period.date,
            previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '',
            createdAndOwnedFiles: mockData.createdAndOwnedFiles,
            previousPeriod: mockData.previousPeriod,
            teamAverage: mockData.teamAverage
        };
    });
    var totals = periods.reduce(function (acc, period) { return ({
        createdAndOwnedFiles: acc.createdAndOwnedFiles + period.createdAndOwnedFiles,
        previousPeriod: acc.previousPeriod + period.previousPeriod,
        teamAverage: acc.teamAverage + period.teamAverage
    }); }, { createdAndOwnedFiles: 0, previousPeriod: 0, teamAverage: 0 });
    return { totals: totals, periods: periods };
};
